import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Login from './pages/Login';
import { ForcedNoRequireAuth } from './auth/Auth';
import Register from './pages/Register';
import PrivateOutlet from './auth/PrivateOutlet';
import ForgetPassword from './pages/ForgetPassword';
import Profile from './pages/Profile';
import MyAccount from './pages/MyAccount';
import Cards from './pages/Cards';
import ChangePassword from './pages/ChangePassword';
import SettingPage from './pages/SettingPage';
import HelpCenter from './pages/HelpCenter';
import Notification from './pages/Notification';
import NewUserSettings from './pages/NewUserSettings';
import AccountList from './pages/AccountList';
import TransactionHistory from './pages/TransactionHistory';
import CategoryExpense from './pages/CategoryExpense';
import Reports from './pages/Reports';
import Statistics from './pages/Statistics';
import ResetPassword from './pages/ResetPassword';
import PasswordUpdate from './pages/PasswordUpdate';
import AccountDetails from './pages/AccountDetails';
import ReportBalance from './pages/Reports/ReportBalance';
import CashFlowReport from './pages/Reports/CashFlowReport';
import usePWAInstall from './hooks/usePWAInstall';
import PWAInstallBottomSheet from './components/Modals/PWAInstallBottomSheet';
import PWAInstallInstructionForIOSBottomSheet from './components/Modals/PWAInstallInstructionForIOSBottomSheet';
import { isDarkModeOn } from './util/helper';
import ReportIncome from './pages/Reports/ReportIncome';

function App() {
    const [isDarkMode, setIsDarkMode] = useState(isDarkModeOn());
    const handleDarkModeToggle = () => {
        const newMode = !isDarkMode;
        setIsDarkMode(newMode);
        localStorage.setItem('darkMode', newMode);
    };

    useEffect(() => {
        if (isDarkMode) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [isDarkMode]);

    usePWAInstall();

    return (
        <HelmetProvider>
            <LanguageProvider>
                <div className="App">
                    {/* Global PWA install modals (must exist on all routes) */}
                    <PWAInstallBottomSheet />
                    <PWAInstallInstructionForIOSBottomSheet />

                    <Routes>
                        <Route
                            exact
                            path="/login"
                            element={
                                <ForcedNoRequireAuth>
                                    <Login />
                                </ForcedNoRequireAuth>
                            }
                        />

                        <Route
                            exact
                            path="/register"
                            element={
                                <ForcedNoRequireAuth>
                                    <Register />
                                </ForcedNoRequireAuth>
                            }
                        />

                        <Route
                            exact
                            path="/forgot-password"
                            element={
                                <ForcedNoRequireAuth>
                                    <ForgetPassword />
                                </ForcedNoRequireAuth>
                            }
                        />

                        <Route
                            exact
                            path="/reset-password"
                            element={
                                <ForcedNoRequireAuth>
                                    <ResetPassword />
                                </ForcedNoRequireAuth>
                            }
                        />

                        <Route path={'/*'} element={<PrivateOutlet />}>
                            <Route
                                exact
                                path=""
                                element={
                                    <Home
                                        handleDarkModeToggle={handleDarkModeToggle}
                                        isDarkMode={isDarkMode}
                                    />
                                }
                            />
                            <Route exact path="new-user" element={<NewUserSettings />} />
                            <Route exact path="profile" element={<Profile />} />
                            <Route exact path="my-account" element={<MyAccount />} />
                            <Route exact path="cards" element={<Cards />} />
                            <Route exact path="password-update" element={<PasswordUpdate />} />
                            <Route exact path="change-password" element={<ChangePassword />} />
                            <Route exact path="settings" element={<SettingPage />} />
                            <Route exact path="help-center" element={<HelpCenter />} />
                            <Route exact path="notification" element={<Notification />} />
                            <Route exact path="accounts" element={<AccountList />} />
                            <Route exact path="account/:id" element={<AccountDetails />} />
                            <Route
                                exact
                                path="transaction-history"
                                element={<TransactionHistory />}
                            />
                            <Route exact path="category-expense" element={<CategoryExpense />} />
                            <Route exact path="reports" element={<Reports />} />
                            <Route exact path="statistics" element={<Statistics />} />
                            <Route exact path="report/income" element={<ReportIncome />} />
                            <Route exact path="report/balance" element={<ReportBalance />} />
                            <Route exact path="report/cash-flow" element={<CashFlowReport />} />
                        </Route>
                    </Routes>
                </div>
            </LanguageProvider>
        </HelmetProvider>
    );
}

export default App;
